import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/hangUp.tsx
var HangUp = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M17 12.4074C15.4269 11.9323 13.7461 11.6753 12 11.6753C10.2539 11.6753 8.5731 11.9323 7 12.4074L7 14.3686C7 14.8038 6.67835 15.1833 6.21923 15.2899L3.28747 15.9706C2.63415 16.1223 2 15.6685 2 15.0493L2 11.5546C2 10.8762 2.38983 10.2423 3.04985 9.93829C4.29767 9.36358 5.62001 8.9053 7 8.57895C8.5981 8.20101 10.2735 8 12 8C13.7265 8 15.4019 8.20101 17 8.57895C18.38 8.9053 19.7023 9.36358 20.9502 9.93829C21.6102 10.2423 22 10.8762 22 11.5546V15.0493C22 15.6685 21.3658 16.1223 20.7125 15.9706L17.7808 15.2899C17.3217 15.1833 17 14.8038 17 14.3686V12.4074Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.5 14.9115C22.5 15.9461 21.4186 16.7043 20.3046 16.4508L17.4478 15.8009C16.6649 15.6227 16.1164 14.9886 16.1164 14.2615V12.891C14.8102 12.5521 13.4292 12.3703 12 12.3703C10.5708 12.3703 9.18985 12.5521 7.88363 12.891V14.2615C7.88363 14.9886 7.33513 15.6227 6.55223 15.8009L3.69545 16.4508C2.58139 16.7043 1.5 15.9461 1.5 14.9115L1.5 11.5745C1.5 10.6928 2.01879 9.83869 2.94009 9.4229C4.20336 8.85278 5.54221 8.39808 6.9395 8.07428C8.55775 7.69927 10.2536 7.5 12 7.5C13.7464 7.5 15.4423 7.69927 17.0605 8.07428C18.4578 8.39808 19.7966 8.85278 21.0599 9.4229C21.9812 9.83869 22.5 10.6928 22.5 11.5745V14.9115Z",
		fill: "currentColor"
	})
});
//#endregion
export { HangUp };
